import styled from 'styled-components';
import { Images } from '@/assets';
import { fonts } from '@/theme/fonts';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

const Header = () => {
  const { i18n } = useTranslation();

  const changeLanguage = useCallback(
    (lang: 'ko' | 'en') => {
      i18n.changeLanguage(lang);
      localStorage.setItem('language', lang);
    },
    [i18n]
  );

  return (
    <Container>
      <LogoWrap>
        <Logo src={Images.PingPongLogo} alt="PingPong Admin" />
        <Title>R2Playground Admin</Title>
      </LogoWrap>
      <LanguageSection>
        <LanguageButton
          $active={i18n.language === 'ko'}
          onClick={() => changeLanguage('ko')}
        >
          한국어
        </LanguageButton>

        <LanguageButton
          $active={i18n.language === 'en'}
          onClick={() => changeLanguage('en')}
        >
          English
        </LanguageButton>
      </LanguageSection>
    </Container>
  );
};

export default Header;

const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
`;

const LogoWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Logo = styled.img`
  width: 36px;
  height: 36px;
`;

const Title = styled.div`
  font-family: ${fonts.family.inter};
  font-weight: ${fonts.weight.bold};
  font-size: 20px;
  line-height: 1;
  color: #111827;
`;

const LanguageSection = styled.div`
  display: flex;
  gap: 8px;
`;

const LanguageButton = styled.button<{ $active: boolean }>`
  width: 72px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid ${({ $active }) => ($active ? '#2563eb' : '#d1d5db')};
  background: ${({ $active }) => ($active ? '#eff6ff' : '#fff')};
  color: ${({ $active }) => ($active ? '#2563eb' : '#6b7280')};
  font-size: 13px;
  font-weight: 600;

  &:hover {
    background: #f9fafb;
  }
`;
